import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
/**
 * button for buying moves on out of moves screen
 */

export default class OOMBuyMovesButton extends OMT_UI_SquareButton {
  constructor(x, y, price, additionalBooster, boosterType) {
    super(x, y, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: additionalBooster ? 445 : 309,
          height: 100,
        },
      },
      options: {
        cacheButton: false,
      },
    });
    this.boosterType = boosterType;
    this.price = price;
    this.createLabelForButton(additionalBooster);

    this.prevRefreshState = true;
    this.refreshState(true);
  }

  onClickDown() {
    // allow clicks always for IAP and only if the user can afford for NO IAPs
    if (G.IAP || G.saveState.getCoins() >= this.price) {
      super.onClickDown();
    }
  }

  refreshState(force = false) {
    if (this.game === null || G.IAP) return; // we continue only for non IAP users
    const canAffordItem = G.saveState.getCoins() >= this.price;
    if (force || canAffordItem !== this.prevRefreshState) {
      this.prevRefreshState = canAffordItem;
      if (canAffordItem) {
        this.setColour(BUTTONCOLOURS.green);
        if (this.iconSprite) this.iconSprite.alpha = 1;
      } else {
        this.setColour(BUTTONCOLOURS.gray);
        if (this.iconSprite) this.iconSprite.alpha = 0.5;
      }
    }
  }

  createLabelForButton(additionalBooster) {
    // booster for out of moves will always be + 5 now
    // const extraMovesBoosterType = !G.IAP ? 'booster#5' : 'booster#6';
    const extraMovesBoosterType = 'booster#5Instant';
    const movesSprite = G.gift.getIconForType(extraMovesBoosterType);
    const priceLabel = new G.LabelTextT(
      `${OMT.language.toLocaleNumber(this.price)}@coin_1@`,
      0, -2, {
        style: 'font-white',
        fontSize: 50,
      }, 0.5, 160,
    );
    this.addChild(priceLabel);

    if (additionalBooster) {
      const boosterSprite = G.gift.getIcon(additionalBooster);
      const icons = new G.LabelTextT(
        `@${movesSprite}@+@${boosterSprite}@`,
        -100, 0, {
          style: 'font-white',
          fontSize: 70,
        }, 0.5, 180,
      );
      priceLabel.x = 110;
      this.addChild(icons);
      this.iconSprite = icons;
    } else {
      const movesIcon = G.makeImage(-100, 0, movesSprite, 0.5, this);
      movesIcon.scale.setTo(0.9);
      priceLabel.x = 40;
      this.addChild(movesIcon);
      this.iconSprite = movesIcon;
    }
  }

  update() {
    this.refreshState();
  }
}
